import Stores from "@/pages/Stores";

export default function Page() {
  return <Stores />;
}
